var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-content',[_c(_vm.layout,{tag:"component"},[_c('router-view',{attrs:{"T_DisplayPeriod":this.T_Period}})],1),_c('PopInfo',{ref:"info"}),_c('PopConfirm',{ref:"confirm"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }